// // import React from 'react'
// // import UploadManager from '../../components/ui/FileManager'

// // const Test = () => {
// //   return (
// //     <div>
// //         <UploadManager/>

// //     </div>
// //   )
// // }

// // export default Test

// import React, { useState, useCallback } from 'react';
// import accountApi from '../../api/accountApi';
// import SearchBar from '../../components/SearchBar';
// import { useSelector } from 'react-redux';
// import AddWorkflowAll from '../../components/workflow/AddWorkflowAll';

// const Test = () => {
//     const token = useSelector((state) => state.auth.access_token);
//     const [accounts, setAccounts] = useState([]);
//     const [loading, setLoading] = useState(false);

//     // useCallback prevents the function from being recreated every render
//     const handleApiSearch = useCallback(async (query) => {
//         // Only hit API if query is 3+ characters
//         if (!query || query.length < 3) {
//             setAccounts([]);
//             return;
//         }

//         try {
//             setLoading(true);
//             const res = await accountApi.searchAccounts(query, token);
//             const data = res.data || [];
//             console.log("API Data:", data);
//             setAccounts(data);
//         } catch (e) {
//             console.error("Search error:", e);
//         } finally {
//             setLoading(false);
//         }
//     }, [token]); // Only recreate if token changes

//     return (
//         // <div className="p-10">
//         //     <div className="max-w-md">
//         //         <SearchBar
//         //             onQueryChange={handleApiSearch}
//         //             placeholder="Search accounts via API..."
//         //         />
                
//         //         {loading && <p className="text-sm text-blue-500 mt-2">Fetching results...</p>}
                
//         //         <div className="mt-5">
//         //             <h4 className="font-bold border-b pb-2">Results (Check Console)</h4>
//         //             <ul className="mt-2 space-y-2">
//         //                 {accounts.map(acc => (
//         //                     <li key={acc.id} className="p-2 bg-gray-50 rounded border">
//         //                         {acc.accountName} - <span className="text-gray-500">{acc.industry}</span>
//         //                     </li>
//         //                 ))}
//         //             </ul>
//         //         </div>
//         //     </div>
//         // </div>
//         <AddWorkflowAll/>
//     );
// };

// export default Test;





import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import invoiceApi from "../../api/invoiceApi";
import hsnApi from "../../api/hsnApi";
import debounce from "lodash/debounce";



const Test = () => {
  const token = useSelector((state) => state.auth.access_token);

  const emptyRow = {
    id: Date.now(),
    description: "",
    hsnSacCode: "",
    quantity: 1,
    unitPrice: 0,
    taxRate: 18,
    taxableAmount: 0,
    taxAmount: 0,
    amount: 0,
  };

  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [saving, setSaving] = useState(false);

  const [hsnResults, setHsnResults] = useState({});
  const [showHsn, setShowHsn] = useState({});

  const [invoiceData, setInvoiceData] = useState({
    customerName: "",
    customerAddress: "",
    customerPhone: "",
    customerEmail: "",
    invoiceDate: new Date().toISOString().slice(0, 10),
    dueDate: new Date(Date.now() + 7 * 86400000).toISOString().slice(0, 10),
    lineItems: [{ ...emptyRow }],
  });


  useEffect(() => {
    setInvoiceNumber(`INV-${Date.now()}`);
  }, []);


  const recalc = (i) => {
    const rows = [...invoiceData.lineItems];
    const r = rows[i];

    const taxable = Number(r.quantity || 0) * Number(r.unitPrice || 0);
    const tax = taxable * (Number(r.taxRate || 0) / 100);

    r.taxableAmount = taxable;
    r.taxAmount = tax;
    r.amount = taxable + tax;

    setInvoiceData({ ...invoiceData, lineItems: rows });
  };


  const totals = useMemo(() => {
    return invoiceData.lineItems.reduce(
      (a, b) => {
        a.subtotal += b.taxableAmount || 0;
        a.tax += b.taxAmount || 0;
        a.total += b.amount || 0;
        return a;
      },
      { subtotal: 0, tax: 0, total: 0 }
    );
  }, [invoiceData.lineItems]);


  const searchHsn = useMemo(
    () =>
      debounce(async (index, value) => {
        if (!value || value.length < 4) return;

        try {
          const res = await hsnApi.searchHsn(value, token);

          const list =
            Array.isArray(res)
              ? res
              : Array.isArray(res?.content)
              ? res.content
              : Array.isArray(res?.data)
              ? res.data
              : [];

          setHsnResults((p) => ({ ...p, [index]: list }));
          setShowHsn((p) => ({ ...p, [index]: true }));
        } catch (e) {
          console.error("HSN error", e);
        }
      }, 400),
    [token]
  );


  const selectHsn = (index, hsn) => {
    const rows = [...invoiceData.lineItems];

    rows[index].hsnSacCode = hsn.hsnCode8;
    rows[index].description ||= hsn.productGroupName;

    // 0.18 → 18
    rows[index].taxRate = (hsn.gstRate || 0) * 100;

    setInvoiceData({ ...invoiceData, lineItems: rows });
    setShowHsn({});

    setTimeout(() => recalc(index), 50);
  };


  const updateRow = (i, f, v) => {
    const rows = [...invoiceData.lineItems];

    rows[i][f] = ["quantity", "unitPrice", "taxRate"].includes(f)
      ? Number(v)
      : v;

    setInvoiceData({ ...invoiceData, lineItems: rows });

    if (f === "hsnSacCode") searchHsn(i, v);
    if (["quantity", "unitPrice", "taxRate"].includes(f))
      setTimeout(() => recalc(i), 50);
  };

  const addRow = () =>
    setInvoiceData({
      ...invoiceData,
      lineItems: [...invoiceData.lineItems, { ...emptyRow, id: Date.now() }],
    });

  const removeRow = (i) =>
    setInvoiceData({
      ...invoiceData,
      lineItems: invoiceData.lineItems.filter((_, x) => x !== i),
    });


  const submit = async () => {
    setSaving(true);

    const payload = {
      invoiceNumber,
      ...invoiceData,

      lineItems: invoiceData.lineItems.map((i, idx) => ({
        description: i.description,
        hsnSacCode: i.hsnSacCode,
        quantity: i.quantity,
        unitPrice: i.unitPrice,
        taxRate: i.taxRate,
        taxableValue: i.taxableAmount,
        taxAmount: i.taxAmount,
        totalAmount: i.amount,
        sortOrder: idx + 1,
      })),

      subTotal: totals.subtotal,
      totalTax: totals.tax,
      grandTotal: totals.total,
    };

    try {
      await invoiceApi.createMedicalInvoice(payload, token);
      alert("Invoice Created");
    } catch (e) {
      console.error(e);
      alert("Backend 400 – check payload");
    }

    setSaving(false);
  };

  const money = (n) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(n);


  return (
    <div className="bg-slate-100 min-h-screen p-6">
      <div className="max-w-6xl mx-auto bg-white rounded-xl shadow">

        <div className="p-6 border-b flex justify-between">
          <div>
            <h1 className="text-2xl font-bold">Invoice</h1>
            <p className="text-gray-400">{invoiceNumber}</p>

            <input
              className="border p-2 rounded mt-3 w-64"
              placeholder="Customer Name"
              value={invoiceData.customerName}
              onChange={(e) =>
                setInvoiceData({ ...invoiceData, customerName: e.target.value })
              }
            />
          </div>
        </div>

        <table className="w-full text-sm">
          <thead className="bg-slate-50">
            <tr>
              {["Desc", "HSN", "Qty", "Rate", "Tax%", "Total", ""].map((h) => (
                <th key={h} className="border px-3 py-2 text-left">
                  {h}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {invoiceData.lineItems.map((r, i) => (
              <tr key={r.id}>
                <td className="border p-2">
                  <input
                    className="w-full"
                    value={r.description}
                    onChange={(e) =>
                      updateRow(i, "description", e.target.value)
                    }
                  />
                </td>

                <td className="border p-2 relative">
                  <input
                    className="w-full"
                    value={r.hsnSacCode}
                    onChange={(e) =>
                      updateRow(i, "hsnSacCode", e.target.value)
                    }
                  />

                  {showHsn[i] && (
                    <div className="absolute bg-white border shadow w-full z-10 max-h-48 overflow-auto">
                      {(Array.isArray(hsnResults[i]) ? hsnResults[i] : []).map(
                        (h, k) => (
                          <div
                            key={k}
                            className="p-2 hover:bg-blue-50 cursor-pointer"
                            onClick={() => selectHsn(i, h)}
                          >
                            {h.hsnCode8} — {h.productGroupName}
                          </div>
                        )
                      )}
                    </div>
                  )}
                </td>

                <td className="border p-2">
                  <input
                    type="number"
                    value={r.quantity}
                    onChange={(e) => updateRow(i, "quantity", e.target.value)}
                  />
                </td>

                <td className="border p-2">
                  <input
                    type="number"
                    value={r.unitPrice}
                    onChange={(e) => updateRow(i, "unitPrice", e.target.value)}
                  />
                </td>

                <td className="border p-2">{r.taxRate}%</td>

                <td className="border p-2 font-semibold">
                  {money(r.amount)}
                </td>

                <td className="border p-2">
                  <button onClick={() => removeRow(i)}>✕</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="p-4">
          <button onClick={addRow} className="bg-green-600 text-white px-4 py-2 rounded">
            + Add Row
          </button>
        </div>

        <div className="flex justify-end p-6">
          <div className="w-72 bg-slate-50 border rounded p-4 space-y-2">
            <div className="flex justify-between">
              <span>Subtotal</span>
              <span>{money(totals.subtotal)}</span>
            </div>
            <div className="flex justify-between">
              <span>Tax</span>
              <span>{money(totals.tax)}</span>
            </div>
            <div className="border-t pt-2 flex justify-between font-bold">
              <span>Total</span>
              <span>{money(totals.total)}</span>
            </div>
          </div>
        </div>

        <div className="p-6 border-t text-right">
          <button
            onClick={submit}
            disabled={saving}
            className="bg-blue-600 text-white px-6 py-2 rounded"
          >
            {saving ? "Saving..." : "Save Invoice"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Test;
